<template>
    <div class="fhv-centent">
        <h4 class="title-topic">Parental Controls</h4>
        <el-table :data="dataLists" border class="fhv-table" size="mini">
            <el-table-column
            type="index"
            width="50">
            </el-table-column>
            <el-table-column label="Terminal MAC(up to 32 settings)" prop="mac"></el-table-column>
            <el-table-column label="Forbidden access site address" prop="url"></el-table-column>
            <el-table-column label="Condition" width="100">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.enable" @change="handleEnable(scope.$index, scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="Operation" width="100">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="fh-btn-contain">
            <el-button type="primary" 
            @click="showAddDialog" :disabled="$G_DEVICE_CFG.isReadOnly">
            Add</el-button>
        </div>
        <el-dialog title="Add Web Site Filtering" :visible.sync="dialogFormVisible" >
            <el-form 
            :model="addFormData"  
            label-width="120px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :rules="formCheck" 
            ref="addForm"
            >
                <el-form-item label="Website" prop="url">
                    <el-input v-model="addFormData.url"></el-input>
                </el-form-item>
                <el-form-item label="Selection Device" prop="mac">
                    <el-radio-group v-model="addFormData.mac" size="small">
                        <el-radio-button 
                        :label="m.mac" v-for="m in macLists" :key="m.mac">
                            {{m.name}}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="confirm">Confirm</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import topo from '../../test/topo_data.json'
export default {
    data(){
        return {
            loading:false,
            dialogFormVisible:false,
            dataLists: [],
            topoData:{},
            addFormData:{
                url:'',
                mac:'',
            },
            formCheck: {
                url:[
                    { required: true, message: 'Website cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(validator.isIP(value,4) || validator.isIP(value,6) || validator.isFQDN(value))
                                callback()
                            else
                                callback(new Error('Website error! e.g. www.google.com or 8.8.8.8'));
                        },
                        trigger: 'blur'
                    }
                ],
                mac:[
                    { required: true, message: 'Selection Device cannot be empty.', trigger: 'change' },
                ]
            }
        }
    },
    created(){
        this.getData()
    },
    computed:{
        macLists(){
            let devices = []
            if(typeof this.topoData.MainBaseInfo === "undefined") return devices
            this.topoData.MainBaseInfo.forEach(element => {
                devices.push({
                    name:element.Name === "" ? element.Mac : element.Name,
                    mac:element.Mac
                })
            });

            if(typeof this.topoData.ChildRouter === "undefined") return devices

            this.topoData.ChildRouter.forEach(element => {
                if(typeof element.ChildBaseInfo !== "undefined")
                {
                    element.ChildBaseInfo.forEach(c =>{
                        devices.push({
                            name:c.Name === "" ? c.Mac : c.Name,
                            mac:c.Mac
                        })
                    })
                }
            });
            
            return devices
        }
    },
    methods: {
        getData(){
            this.loading = true
            axios
            .post("/JSONAPI",{cmdType:"GET_PARENTAL_CONTROLS"})
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.dataLists = response.data.urlRules
                    this.topoData = response.data.topoData
                }
                else
                    this.$message.error(`GET data failed!Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('GET data failed! Network connection error!')
            })
        },
        addData(){
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"ADD_PARENTAL_CONTROLS",
                enable:true,
                url:this.addFormData.url,
                mac:this.addFormData.mac,
            })
            .then((response)=>{
                if(response.data.ret === 0)
                {
                    this.getData()
                    this.$message.success('Add Web Site Filtering Success!')
                }
                else
                {
                    this.loading = false
                    this.$message.error(`Add Web Site Filtering Failed! Error:${response.data.errMsg}`)
                }
                    
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Add Web Site Filtering Failed! Network connection error!')
            })
        },
        showAddDialog(){
            if(this.dataLists.length === 4)
            {
                this.$message.error('up to 32 settings!');
            }
            else
            {
                this.dialogFormVisible = true
            }
        },
        confirm(){
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.dialogFormVisible = false
                    this.addData()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleEnable(index, row){ // 规则开关操作
            this.loading = true
            axios
            .post("/JSONAPI",{
                cmdType:"ENABLE_PARENTAL_CONTROLS",
                enable: row.enable,
                index: index + 1
            })
            .then((response)=>{
                this.loading = false
                if(response.data.ret === 0)
                {
                    this.$message.success('Configuration Success!')
                }
                else
                {
                    this.$message.error(`Configuration Failed! Error:${response.data.errMsg}`)
                }
                    
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Configuration Failed! Network connection error!')
            })
        },
        handleDelete(index, row){ // 规则删除操作
            let _urlRules = JSON.parse( JSON.stringify( this.dataLists ) )
            this.loading = true
            _urlRules.splice(index,1)
            axios
            .post("/JSONAPI",{
                cmdType: "DEL_PARENTAL_CONTROLS",
                urlRules: _urlRules
            })
            .then((response)=>{
                if(response.data.ret === 0)
                {
                    this.getData()
                    this.$message.success('Configuration Success!')
                }
                else
                {
                    this.loading = false
                    this.$message.error(`Configuration Failed! Error:${response.data.errMsg}`)
                }
                    
            })
            .catch((error) => {
                this.loading = false
                this.$message.error('Configuration Failed! Network connection error!')
            })
        }
    }
}
</script>

<style scoped>
.fhv-form{
    margin-left: 15%
}

@media (max-width: 768px) {
    .fhv-form{
        margin-left: 0;
    }
}
</style>